import React from "react";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import Utils from "../../../utility";
import { reportedUsersService } from "../../../services/index";

export default function CustomizedSwitches(props) {
  const [state, setState] = React.useState({
    checkedA: true,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const theme = createMuiTheme({
    overrides: {
      MuiSwitch: {
        root: {
          height: 15,
          width: 35,
          padding: 0,
          // display: 'flex',
        },
        switchBase: {
          padding: 2,
          // Controls default (unchecked) color for the thumb
          color: "white",
        },
        colorSecondary: {
          "&$checked": {
            // Controls checked color for the thumb
            color: "white",
          },
        },
        thumb: {
          width: 10,
          height: 10,
          boxShadow: "none",
        },
        track: {
          // Controls default (unchecked) color for the track
          opacity: 100,
          backgroundColor: "#00AE1D",
          "$checked$checked + &": {
            // Controls checked color for the track
            opacity: 100,
            backgroundColor: "#FF0027",
          },
        },
      },
    },
  });

  const unblockReport = async () => {

    const reqObj = {
      userID: props.rows,
    };
    const [err, res] = await Utils.parseResponse(
      reportedUsersService.unblockUser(reqObj)
    );
    props.getblockUsers(res);
    setState({...state})
  };

  return (
    <ThemeProvider theme={theme}>
      <FormControlLabel
        control={
          <Switch
            checked={state.checkedA}
            onClick={unblockReport}
            onChange={handleChange}
            name="checkedA"
          />
        }
        label=""
      />
    </ThemeProvider>
  );
}
